exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".photo-col:hover .photo-container[data-v-723f42f6]{box-shadow:0 0 0 2px #4382ce}.photo-container[data-v-723f42f6]{padding-top:75%;background-repeat:no-repeat;background-size:cover;background-position:50%;cursor:pointer;transition:all .2s ease}.markers[data-v-723f42f6]{position:absolute;bottom:3px;left:10px;background-color:#000;display:flex;width:20px;justify-content:space-between;padding:2px}.markers li[data-v-723f42f6]{width:4px;height:4px;z-index:1}.remove[data-v-723f42f6]{background-color:red}.watermark-major[data-v-723f42f6]{background-color:orange}.watermark-minor[data-v-723f42f6]{background-color:#ff0}.duplicate[data-v-723f42f6]{background-color:cyan}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-723f42f6","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/property-qc/handlers/ImageRuleHandler.vue
// module id = 830
// module chunks = 0